import IconButton from "@mui/material/IconButton";
import StarOutline from "@mui/icons-material/StarSharp";
import { ExpandMore, ExpandLess } from "@mui/icons-material";

import { IAccordionProps } from "./Accordion.types";
import { Container, Wrapper } from "./Accordion.styled";

/**
 *  <Accordion
 *    expanded={false}
 *    header={<></>}
 *    onClick={() => {}}
 *  >
 *    {children}
 *  </Accordion>
 */

export function Accordion({
  expanded,
  onExpand,
  header,
  options,
  children,
  ...props
}: IAccordionProps) {
  return (
    <Container expanded={expanded} {...props}>
      <Wrapper>
        <div style={{ width: "100%" }}>{header}</div>
        <div style={{ display: "flex", flexDirection: "row", gap: "16px", alignItems: "center" }}>
          {options}
          <IconButton color="primary" size="medium" onClick={onExpand}>
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </div>
      </Wrapper>
      {expanded && children}
    </Container>
  );
}
